import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import { BoxGrid } from './Box';
import { Dustbin } from './Dustbin';
import BuilderPage from './EditForm';

const Container = (props: any) => {
  const [inputId, setInputId] = useState<string>('');
  return (
    <>
      <Grid item xs={5}>
        <Dustbin allowedDropEffect="any" items={props.items} setItems={props.setItems} setInputId={setInputId} />
      </Grid>
      <Grid item xs={4}>
        {inputId != '' ? <BuilderPage inputId={inputId} items={props.items} setItems={props.setItems} setInputId={setInputId} /> : ""}
      </Grid>
      <Grid item xs={3}>
        <Box>
          {
            props?.htmlType.map((e: any) => {
              return <BoxGrid key={e.id} name={e.type} icon={e.icon} setItems={props.setItems} items={props.items} />
            })
          }
        </Box>
      </Grid>
    </>
  );
};

export default Container;
